const domain = window['location']['protocol'] + '//' + window['location']['hostname'];

export const environment = {
  production: true,
  apiURL: domain,
  enabledCustomerRequest: false,
};



// WEBPACK FOOTER //
// /opt/app/src/environments/environment.ts